import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import unalLogo from '../gundogdudoviz1.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <div className="logo-icon">
              <img src={unalLogo} alt="GÜNDOĞDU DÖVİZ VE ALTIN Logo" className="logo-img" height={80} width={80} />
            </div>
            <div className="logo-text-container">
              <span className="logo-text">GÜNDOĞDU DÖVİZ VE ALTIN</span>
              <span className="logo-subtitle">Sınırlı Yetkili Müessese</span>
              <span className="logo-group">B Grubu</span>
            </div>
          </Link>

          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li>
                <Link 
                  to="/" 
                  className={`nav-link ${isActive('/') ? 'active' : ''}`}
                  onClick={(event) => { if (window.location.pathname === '/') event.preventDefault(); setIsMenuOpen(false); }}
                >
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link 
                  to="/hakkimizda" 
                  className={`nav-link ${isActive('/hakkimizda') ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link 
                  to="/kurumsal" 
                  className={`nav-link ${isActive('/kurumsal') ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Kurumsal
                </Link>
              </li>
              <li>
                <Link 
                  to="/iletisim" 
                  className={`nav-link ${isActive('/iletisim') ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  İletişim
                </Link>
              </li>
              <li>
                <Link 
                  to="/yasal-uyari" 
                  className={`nav-link ${isActive('/yasal-uyari') ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Yasal Uyarı
                </Link>
              </li>
            </ul>
          </nav>

          <button className="menu-toggle" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;